import { InterceptedCoroutine142wh200e9wbr as InterceptedCoroutine } from './InterceptedCoroutine.mjs';
import {
  _Result___init__impl__xyqfz83hut4nr3dfvi3 as _Result___init__impl__xyqfz8,
  _Result___get_value__impl__bjfvqg2ei4op8d4d2m as _Result___get_value__impl__bjfvqg,
  _Result___get_isFailure__impl__jpirivrr0d11rbi6gb as _Result___get_isFailure__impl__jpiriv,
  Result__exceptionOrNull_impl_p6xea9ty3elzpd9eo3 as Result__exceptionOrNull_impl_p6xea9,
  Companion_instance2oawqq9qiaris as Companion_instance,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../Result.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../hacks.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from './intrinsics/Intrinsics.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from './Continuation.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_dummyGenerator() {
  _init_properties_GeneratorCoroutineImpl_kt__4u0pi3();
  return dummyGenerator;
}
var dummyGenerator;
function get_GeneratorFunction() {
  _init_properties_GeneratorCoroutineImpl_kt__4u0pi3();
  return GeneratorFunction;
}
var GeneratorFunction;
function access$_get_jsIterators__geagmj($this) {
  return $this.uc_1;
}
function access$_get_unknown__2v7dtz($this) {
  return $this.xc_1;
}
function access$_get_savedResult__bwlkfn($this) {
  return $this.yc_1;
}
var GeneratorCoroutineImplClass;
function GeneratorCoroutineImpl() {
  if (GeneratorCoroutineImplClass === VOID) {
    class $ extends InterceptedCoroutine() {
      constructor(resultContinuation) {
        super();
        this.tc_1 = resultContinuation;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.uc_1 = [];
        var tmp_0 = this;
        var tmp0_safe_receiver = this.tc_1;
        tmp_0.vc_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.pc();
        this.wc_1 = false;
        this.xc_1 = _Result___init__impl__xyqfz8(Symbol());
        this.yc_1 = this.xc_1;
      }
      pc() {
        return ensureNotNull(this.vc_1);
      }
      qc(result) {
        if (_Result___get_value__impl__bjfvqg(this.xc_1) === _Result___get_value__impl__bjfvqg(this.yc_1))
          this.yc_1 = result;
        if (this.wc_1)
          return Unit_instance;
        // Inline function 'kotlin.Result.getOrNull' call
        var this_0 = this.yc_1;
        var tmp;
        if (_Result___get_isFailure__impl__jpiriv(this_0)) {
          tmp = null;
        } else {
          var tmp_0 = _Result___get_value__impl__bjfvqg(this_0);
          tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
        }
        var currentResult = tmp;
        var currentException = Result__exceptionOrNull_impl_p6xea9(this.yc_1);
        this.yc_1 = this.xc_1;
        var current = this;
        while (true) {
          $l$loop: while (true) {
            // Inline function 'kotlin.coroutines.GeneratorCoroutineImpl.isCompleted' call
            if (!!(current.uc_1.length === 0)) {
              break $l$loop;
            }
            // Inline function 'kotlin.coroutines.GeneratorCoroutineImpl.getLastIterator' call
            var this_1 = current;
            var jsIterator = this_1.uc_1[this_1.uc_1.length - 1 | 0];
            // Inline function 'kotlin.also' call
            var this_2 = currentException;
            currentException = null;
            var exception = this_2;
            this.wc_1 = true;
            try {
              var step = exception == null ? jsIterator.next(currentResult) : jsIterator.throw(exception);
              currentResult = step.value;
              currentException = null;
              if (step.done) {
                // Inline function 'kotlin.coroutines.GeneratorCoroutineImpl.dropLastIterator' call
                var this_3 = current;
                // Inline function 'kotlin.js.asDynamic' call
                access$_get_jsIterators__geagmj(this_3).pop();
              }
              if (!(_Result___get_value__impl__bjfvqg(this.xc_1) === _Result___get_value__impl__bjfvqg(this.yc_1))) {
                // Inline function 'kotlin.Result.getOrNull' call
                var this_4 = this.yc_1;
                var tmp_1;
                if (_Result___get_isFailure__impl__jpiriv(this_4)) {
                  tmp_1 = null;
                } else {
                  var tmp_2 = _Result___get_value__impl__bjfvqg(this_4);
                  tmp_1 = (tmp_2 == null ? true : !(tmp_2 == null)) ? tmp_2 : THROW_CCE();
                }
                currentResult = tmp_1;
                currentException = Result__exceptionOrNull_impl_p6xea9(this.yc_1);
                this.yc_1 = this.xc_1;
              } else if (currentResult === get_COROUTINE_SUSPENDED())
                return Unit_instance;
            } catch ($p) {
              if ($p instanceof Error) {
                var e = $p;
                currentException = e;
                // Inline function 'kotlin.coroutines.GeneratorCoroutineImpl.dropLastIterator' call
                var this_5 = current;
                // Inline function 'kotlin.js.asDynamic' call
                access$_get_jsIterators__geagmj(this_5).pop();
              } else {
                throw $p;
              }
            }
            finally {
              this.wc_1 = false;
            }
          }
          this.ad();
          var completion = ensureNotNull(this.tc_1);
          if (completion instanceof GeneratorCoroutineImpl()) {
            current = completion;
          } else {
            var tmp_3;
            if (!(currentException == null)) {
              // Inline function 'kotlin.coroutines.resumeWithException' call
              // Inline function 'kotlin.Companion.failure' call
              var exception_0 = ensureNotNull(currentException);
              var tmp$ret$10 = _Result___init__impl__xyqfz8(createFailure(exception_0));
              completion.rc(tmp$ret$10);
              tmp_3 = Unit_instance;
            } else {
              // Inline function 'kotlin.coroutines.resume' call
              // Inline function 'kotlin.Companion.success' call
              var value = currentResult;
              var tmp$ret$12 = _Result___init__impl__xyqfz8(value);
              completion.rc(tmp$ret$12);
              tmp_3 = Unit_instance;
            }
            return tmp_3;
          }
        }
      }
      rc(result) {
        return this.qc(result);
      }
    }
    initMetadataForClass($, 'GeneratorCoroutineImpl', VOID, VOID, [InterceptedCoroutine(), Continuation()]);
    GeneratorCoroutineImplClass = $;
  }
  return GeneratorCoroutineImplClass;
}
function isGeneratorSuspendStep(value) {
  _init_properties_GeneratorCoroutineImpl_kt__4u0pi3();
  return value != null && value.constructor === get_GeneratorFunction();
}
var properties_initialized_GeneratorCoroutineImpl_kt_yzcfjb;
function _init_properties_GeneratorCoroutineImpl_kt__4u0pi3() {
  if (!properties_initialized_GeneratorCoroutineImpl_kt_yzcfjb) {
    properties_initialized_GeneratorCoroutineImpl_kt_yzcfjb = true;
    dummyGenerator = function *(COROUTINE_SUSPENDED, generatorRef) {
      var resultOrSuspended = generatorRef();
      if (resultOrSuspended === COROUTINE_SUSPENDED)
        resultOrSuspended = yield resultOrSuspended;
      return resultOrSuspended;
    };
    GeneratorFunction = get_dummyGenerator().constructor.prototype;
  }
}
//region block: exports
export {
  access$_get_jsIterators__geagmj as access$_get_jsIterators__geagmj3234lk8d9q7ro,
  access$_get_savedResult__bwlkfn as access$_get_savedResult__bwlkfn2h5qcmd9ffu3u,
  access$_get_unknown__2v7dtz as access$_get_unknown__2v7dtz2ojw8x67rbar8,
  GeneratorCoroutineImpl as GeneratorCoroutineImpl2pzxhv55we2g3,
  get_dummyGenerator as get_dummyGeneratoryu26m7xm6osk,
  isGeneratorSuspendStep as isGeneratorSuspendStepcb59h14on5am,
};
//endregion

//# sourceMappingURL=GeneratorCoroutineImpl.mjs.map
